var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Modal", { attrs: { isOpen: _vm.isOpen } }, [
    _c("div", { staticClass: "qr-code-expired-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("@static/img/warning.svg"),
          width: "72",
          height: "72",
          alt: "warning-icon"
        }
      }),
      _c("p", { staticClass: "title", attrs: { "data-testid": "headtitle" } }, [
        _vm._v("Your QR code is expired")
      ]),
      _c("p", { attrs: { "data-testid": "subtitle" } }, [
        _vm._v("You can click Retry to regenerate QR code")
      ]),
      _c(
        "div",
        { staticClass: "btn-wrapper" },
        [
          _c(
            "EpButton",
            {
              staticClass: "btn retry",
              attrs: { "data-testid": "retry-button" },
              on: { click: _vm.handleRetry }
            },
            [_vm._v("Retry")]
          ),
          _c(
            "EpButton",
            {
              staticClass: "btn newpayment",
              attrs: { "data-testid": "newpayment-button" },
              on: { click: _vm.handleNewPayment }
            },
            [_vm._v(" New Payment ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }